

















































import Vue from 'vue';
import moment from 'moment';
import ProductState, {
  getProductStateColor,
} from '@/core/typings/enums/ProductState';
import ProductThumbnail from '@/web/components/products/ProductThumbnail.vue';

export default Vue.extend({
  name: 'ProductCard',
  components: {
    ProductThumbnail,
  },
  props: {
    product: {
      type: Object as () => ProductResponse,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: true,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    date: function (value: string): string {
      if (!value) return '';
      return moment(value).format('MMM DD, yyyy');
    },
  },
  computed: {
    color(): string {
      return getProductStateColor(this.product.productState);
    },
  },
});
